
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/freshsales",
      function () {
        return require("private-next-pages/destinations/freshsales.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/freshsales"])
      });
    }
  